<template>
<div class="my-reserve">
       <div class="ls-tabs">
          <div 
          :class="'tab' + (active === 1 ? ' active' : '')"
          @click="active = 1"
          >
            <span>预约看车</span>
            <div class="btn-tag">
              <div class="line"></div>
            </div>
          </div>
          <div 
          :class="'tab' + (active === 2 ? ' active' : '')"
          @click="active = 2"
          >
            <span>预约评估</span>
            <div class="btn-tag">
              <div class="line"></div>
            </div>
          </div>
       </div>
       <div v-show="active === 1" class="list" v-if="viewDataList.length > 0">
          <div class="resev-item" v-for="item in viewDataList" :key="item.uuid" @click="navigateTo(`/t12?id=${item.pageid}&psn=${item.psn}`)">
            <div class="row"><div class="field">预约时间</div><div class="value">{{item.time}}</div></div>
            <div class="row"><div class="field">预约车型</div><div class="value">{{item.title}}</div></div>
            <div class="row"><div class="field">价格</div><div class="value">{{item.price}}万</div></div>
            <!-- <img src="https://assets.rurushishi.com/yq-rs-make/car/mobile/images/icons/icon-pay-success.png" class="status-tag"/> -->
          </div>
       </div>
       <div v-show="active === 1" class="no-data" v-else-if="viewLoaded && viewDataList.length === 0">
          <img src="https://assets.rurushishi.com/yq-rs-make/car/mobile/images/empty-content.png" class="emp-img"/>
          <span class="emp-txt">暂无预约看车记录</span>
       </div>
       <div v-show="active === 2" class="list" v-if="evaluateDataList.length > 0">
          <div class="resev-item" v-for="item in evaluateDataList" :key="item.uuid">
            <div class="row"><div class="field">预约时间</div><div class="value">{{item.time}}</div></div>
            <div class="row"><div class="field">车型品牌</div><div class="value">{{item.manufactor}}</div></div>
            <div class="row"><div class="field">预约地址</div><div class="value">{{item.useraddress}}</div></div>
            <!-- <img src="https://assets.rurushishi.com/yq-rs-make/car/mobile/images/icons/icon-pay-success.png" class="status-tag"/> -->
          </div>
       </div>
       <div v-show="active === 2" class="no-data" v-else-if="evaluateLoaded && evaluateDataList.length === 0">
          <img src="https://assets.rurushishi.com/yq-rs-make/car/mobile/images/empty-content.png" class="emp-img"/>
          <span class="emp-txt">暂无预约评估记录</span>
       </div>
     </div>
</template>

<script>
import { mapState } from "vuex";
import { getClueList } from '../api'
import { deepClone } from '../utils'
import { Indicator } from 'mint-ui'

export default {
  components: {},
  props: {},
  data() {
    return {
      active: 1,
      queryParams: {
        page: 1,
        row: 20
      },
      viewDataList: [],
      viewLoaded: false,
      evaluateDataList: [],
      evaluateLoaded: false
    };
  },
  watch: {
    //监听用户信息加载完，默认加载第一个Tab列表
    userInfo(newUserInfo){
      if(newUserInfo){
        this.getDataList().then(res => {
          this.viewLoaded = true
        })
      }
    },
    active(tab){
      if(tab === 2 && this.evaluateDataList.length === 0){
        this.getDataList().then(res => {
          this.evaluateLoaded = true
        })
      }
    }
  },
  computed: {
    ...mapState([
      "userInfo"
    ])
  },
  methods: {
    navigateTo(url){
      this.$router.push(url)
    },
    getQueryParams(){
      let queryParams = deepClone(this.queryParams)
      const {user : {appid, openid}} = this.userInfo
      queryParams.qc_refereeopenid = openid
      queryParams.qc_appid = appid
      if(this.active === 1){
        queryParams.qc_atype = 2
        delete queryParams.qc_atypeEstimate
      }else if(this.active === 2){
        queryParams.qc_atypeEstimate = 1
        delete queryParams.qc_atype
      }
      return queryParams
    },
    async getDataList(){
      const params = this.getQueryParams()
      Indicator.open({
        text: 'Loading...',
        spinnerType: 'fading-circle'
      });
      const ret = await getClueList(params)
      Indicator.close()
      if(ret.code === 0 && ret.data){
        const { records } = ret.data
        const list = records.map(item => {
        const extinfo = JSON.parse(item.extinfo)
          return {
            title: extinfo.title,
            time: item.plantime,
            manufactor: item.manufactor,
            useraddress: item.useraddress,
            price: (extinfo.price / 1000000).toFixed(2),
            pageid: item.pageid,
            psn: extinfo.psn,
            uuid: item.uuid
          }
        })
        if(this.active === 1){
          this.viewDataList = this.viewDataList.concat(list)
        }else if(this.active === 2){
          this.evaluateDataList = this.evaluateDataList.concat(list)
        }
      }
      console.log(params)
    }
  },
  beforeCreate() {},
  created() {

  },
  mounted() {

  }
};
</script>
<style lang="scss" scoped>
.my-reserve{
    padding: 0.30407459963511047rem 0.30407459963511047rem 0px 0.30407459963511047rem;
    .ls-tabs{
        display: flex;
        .tab{
            display: flex;
            flex-direction: column;
            margin-right: 0.5067909993918508rem;
            font-size: 0.3243462396107845rem;
            .btn-tag{
                display: flex;
                justify-content: center;
                height: 0.10135819987837016rem;
                padding: 0.09067909993918508rem 0px 0.13371639975674033rem 0px;
                .line{
                    background-color: transparent;
                    width: 0.010135819987837016rem;
                    height: 0.0608149199270221rem;
                    border-radius: 2px;
                    transition: width 1s;
                }
            }
        }
        .active{
            color:#0D89FF;
            font-weight: 400;
            .btn-tag{
                .line{
                    background-color: #0D89FF;
                    width: 0.7095073991485912rem;
                    height: 0.0608149199270221rem;
                    border-radius: 2px;
                    transition: width .2s;
                }
            }
        }
    }
    .list{
        display: flex;
        flex-direction: column;
        position: relative;
        .resev-item{
            background:#fff;
            box-shadow: 0px 0.040543279951348064rem 0.15203729981755523rem 0px rgba(0, 0, 0, 0.06);
            border-radius: 5px;
            padding: 0px 0.30407459963511047rem;
            margin-bottom: 0.30407459963511047rem;
            .row{
                display: flex;
                align-items: center;
                border-bottom: solid 1px #f1f1f1;
                padding: 0.2533954996959254rem 0px;
                .field{
                    width: 1.3176565984188122rem;
                    color:#888888;
                    font-size: 0.2635313196837624rem;
                }
                .value{
                    flex: 1;
                    color:#555555;
                    font-size: 0.2635313196837624rem;
                }
            }
        }
        .status-tag{
            width: 1.0135819987837016rem;
            height: 1.0135819987837016rem;
            position: absolute;
            right: 0.20271639975674033rem;
            top: 0.20271639975674033rem;
        }
    }
  .no-data{
    display:flex;
    flex-direction:column;
    align-items: center;
    padding-top: 1rem;
    .emp-img{
      max-width: 5rem;
    }
    .emp-txt{
      padding: .2rem;
      font-size: .3rem;
      color:#999;
    }
  }
}
</style>